import request from '../utils/request'
import {
    ref
} from 'vue'
import {
    useRoute
} from 'vue-router'
const $route = useRoute()

import {
    fromPromise,
    of ,
    from,
} from 'rxjs'
import {
    catchError,
    mergeMap,
    map,
    filter,
} from 'rxjs/operators'


console.log(process.env.NODE_ENV);
let env = process.env.NODE_ENV
let baseApi = env === 'development' ? '/api' : 'https://www.sznews.com/ranking'
let searchApi = env === 'development' ? '/searchApi' : 'https://activity.sznews.com/2021/qzss.php?s='
let praiseApi = env === 'development' ? '/praiseApi' : 'https://countpage2.sznews.com/2022/stat/web.php?s='
let statsApi = env === 'development' ? '/statsApi' : 'https://countpage2.sznews.com/2022/stat/web.php?s='


let logoList = ref([
    require('../assets/logo_jzApp.png'),
    require('../assets/logo_futian.png'),
    require('../assets/logo_luoohu.png'),
    require('../assets/logo_longgang.png'),
    require('../assets/logo_longhua.png'),
    require('../assets/logo_guangming.png'),
    require('../assets/logo_dapeng.png'),


])

let categoryList = [

    {
        id: '237446',
        name: '头条',
        page: 1,
        list: [],
        cursor: 0,
    },
    {
        id: '311502',
        name: '热点',
        page: 1,
        list: [],
        cursor: 0,
    },
    {
        id: '311503',
        name: '视频',
        page: 1,
        list: [],
        cursor: 0,
    },
    {
        id: '311504',
        name: '图片',
        page: 1,
        list: [],
        cursor: 0,
    },


]

export function fetchCategory(categoryId) {

    console.log(categoryId);
    if (categoryList.length) return of(categoryList)
    else {
        return from(
            request({
                url: `${baseApi}/type/flyCardCounty.json`,
                method: 'get'
            })
        )
    }
}

export function fetchArticleList(categoryId, page = 1) {

    return from(
        request({
            // url: `${baseApi}/news/flyCard/json/${categoryId}/${categoryId}_${page}.json`,
            url: `${baseApi}/${categoryId}_page_${page}.json`,
            method: 'get'
        }))

}

export function fetchDetail(articleId) {

    return from(
        request({
            url: `${baseApi}/${articleId}.json`,
            method: 'get',
        }))
}


// export function fetchA



export function fetchSearchList(data) {
    return from(
        request({
            url: `${searchApi}/index/index/index`,
            method: 'post',
            data,
        })
    )
}


export function getPraiseCount(id) {
    let fd = new FormData()
    fd.append('content_id', id)
    return from(
        request({
            url: `${praiseApi}/zan/stat/getZan`,
            method: 'post',
            data: fd
        })
    )

}


export function setPraiseCount(id) {
    let fd = new FormData()
    fd.append('content_id', id)
    return from(
        request({
            url: `${praiseApi}/zan/stat/addZan`,
            method: 'post',
            data: fd
        })
    )

}


export function setStatsCount(url) {
    let fd = new FormData()
    fd.append('url', url)
    fd.append('site', 'sznews.com')
    fd.append('channel', '')
    return from(
        request({
            url: `${statsApi}/index/stat/setMobileView`,
            method: 'post',
            data: fd
        })
    )

}